// extracted by mini-css-extract-plugin
module.exports = {"root":"HeadBanner_root_3FUyK","variant-0":"HeadBanner_variant-0_3fV_k","nav":"HeadBanner_nav_1f0XS"};